import MuiMenuItem from '@zenbusiness/zui/MenuItem';
import { styled } from '@zenbusiness/zui/styles';

const MenuItemStyle = ({ theme }) => ({
  color: theme.palette.text.primary,
  '&.MuiButtonBase-root': {
    fontSize: '18px',
    fontWeight: '600',
    padding: '24px 0px'
  }
});

export const TitleStyles = ({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: '32px!important',
    lineHeight: '40px!important'
  }
});

export const MenuItemStyled = styled(MuiMenuItem)(MenuItemStyle);
